import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import { BUILD_NUM } from '../BuildConstants';
import { logger } from '../core/services/loggerService';
import * as Api from './Api';
import { Utilities } from './Utilities';

export const interceptorResponseRejected = (
  err: AxiosError,
): Promise<AxiosError> => {
  const { config } = err;
  const { url = 'PATH UNAVAILABLE', baseURL, method, data: requestData } =
    config || {};
  const statusCode = err.response?.status;
  const responseData = err.response?.data;
  const ddCorrelationId = err.response?.['x-correlation-id'];
  const ddTraceId = err.response?.['x-trace-id'];
  const logData = {
    baseURL,
    method,
    requestData,
    responseData,
    url,
    statusCode,
    ddCorrelationId,
    ddTraceId,
  };
  const message = `${url} API failed`;

  /**
   * We log all API error as error as of now
   * Some cases we do not get response object in
   * interceptor error object because of CORS
   * we log status code, We will observe this over a time
   * and check if we can depend on error code always.
   */
  logger.error(message, logData);

  return Promise.reject(err);
};

export const interceptorResponseSuccess = (
  response: AxiosResponse,
): Promise<AxiosResponse> => {
  const { config } = response;
  const { url = 'PATH UNAVAILABLE', baseURL, method, data } = config || {};

  if (!response.data?.Success && !url.includes('json')) {
    logger.warn(`${url} API success failed`, { baseURL, method, data, url });
  }

  return Promise.resolve(response);
};

export const setupAxios = (settings, loadedGeo): void => {
  const axiosConfig = (
    config: AxiosRequestConfig,
    baseURL: string,
    whiteLabel: string,
  ): void => {
    // ICH+2022.03.28
    // Investigate this Axios configuration to avoid need
    // for linting rule disable

    /* eslint-disable no-param-reassign */
    config.headers.common['Flipdish-White-Label-Id'] = whiteLabel;
    config.headers.common['Flipdish-App-Version'] = BUILD_NUM;
    config.headers.common['Content-Type'] = 'application/json; charset=utf-8';
    config.headers.common['Flipdish-App-Type'] = 'Web';
    if (loadedGeo) {
      config.headers.common[
        'X-Coordinates'
      ] = `${loadedGeo.Latitude},${loadedGeo.Longitude},${Api.LocationCertainty.Settings}`;
    }
    config.baseURL = baseURL;
    config.withCredentials = true;
    /* eslint-enable no-param-reassign */

    const flipdishToken = Utilities.getFlipdishTokenCookie();
    if (flipdishToken) {
      axios.defaults.headers.common['X-Flipdish-Token'] = flipdishToken;
    }
  };

  if (settings?.restaurant) {
    axiosConfig(axios.defaults, settings.server, settings.restaurant);

    axios.interceptors.response.use(
      interceptorResponseSuccess,
      interceptorResponseRejected,
    );
  } else {
    logger.error('no WLID present');
  }
};
